import type { AvatarProps as MuiAvatarProps, SxProps, Theme } from '@mui/material'
import MuiAvatar from '@mui/material/Avatar'
import { FC } from 'react'

import { LuneThemeNew } from '../theme'

export const AVATAR_COLORS = [
    LuneThemeNew.palette.Data100,
    LuneThemeNew.palette.Data400,
    LuneThemeNew.palette.Data500,
    LuneThemeNew.palette.Data1000,
    LuneThemeNew.palette.Data1300,
    LuneThemeNew.palette.Data1500,
    LuneThemeNew.palette.Data1900,
    LuneThemeNew.palette.Data2100,
] as const

export const getInitials = (
    email: string,
    firstname?: string | null,
    lastname?: string | null,
): string => {
    if (firstname && lastname) return `${firstname[0]}${lastname[0]}`.toUpperCase()
    if (firstname) return firstname.substring(0, 2).toUpperCase()
    if (lastname) return lastname.substring(0, 2).toUpperCase()
    return email.substring(0, 2).toUpperCase()
}

export const getAvatarColor = (seed: string): string => {
    const normalizedSeed = seed.trim().toLowerCase()
    let hash = 0

    for (let i = 0; i < normalizedSeed.length; i++) {
        hash = (hash * 31 + normalizedSeed.charCodeAt(i)) >>> 0
    }

    return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

const toSxArray = (sx?: SxProps<Theme>): SxProps<Theme>[] => {
    if (!sx) return []
    return Array.isArray(sx) ? sx : [sx]
}

export type AvatarProps = MuiAvatarProps & {
    email: string
    firstname?: string | null
    lastname?: string | null
    testId?: string
}

const Avatar: FC<AvatarProps> = ({
    children,
    email,
    firstname,
    lastname,
    sx,
    testId,
    ...props
}) => {
    const initials = getInitials(email, firstname, lastname)
    const backgroundColor = getAvatarColor(email)
    const avatarSx = [
        {
            backgroundColor,
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: 700,
        },
        ...toSxArray(sx),
    ] as SxProps<Theme>

    return (
        <MuiAvatar data-testid={testId} sx={avatarSx} {...props}>
            {children ?? initials}
        </MuiAvatar>
    )
}

export default Avatar
